import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDHo9lkZOUhz1X8IuhE-zM6xp72M6Qq7IE",
  authDomain: "rwhite-30f46.firebaseapp.com",
  projectId: "rwhite-30f46",
  storageBucket: "rwhite-30f46.firebasestorage.app",
  messagingSenderId: "104261783804",
  appId: "1:104261783804:web:525cee7794ec126feb0779",
  measurementId: "G-VMRV2Q3N8F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// eslint-disable-next-line no-unused-vars
export const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);